/**
 * Creates select object for dropdown
 * @param {array} outlookContacts - array of email addresses from outlook
 * @param {array} addressContacts - array of email addresses GTZ
 * @param {array} recentContacts - array of recent email addresses GTZ
 * @return {object} - Grouped object for select dropdown
 */
export const createGroupedOptions = (outlookContacts, addressContacts, recentContacts) => {
  const mergedContacts = outlookContacts.concat(addressContacts);
  const groupedOptions = [
    {
      label: 'Recent People',
      options: recentContacts.map((option) => (
        { value: option.userName, label: option.email, name: option.customerName })),
    },
    {
      label: 'Other Suggestions',
      options: mergedContacts.map((option) => (
        { value: option.userName, label: option.email, name: option.displayName || option.customerName })),
    },
  ];
  return groupedOptions;
};

export default createGroupedOptions;
